declare module 'sha.js/sha256.js' {
  import { sha256 } from 'sha.js';

  export default sha256;
}
